import React from 'react'
import * as biIcons from 'react-icons/bi'
import * as bsIcons from 'react-icons/bs'
import * as ioIcons from 'react-icons/io'
import * as io5Icons from 'react-icons/io5'
import * as riIcons from 'react-icons/ri'

import { COLORS } from '@btime/constants'

const Icon = ({ name, group, color, size, onClick }) => {
  group = group || 'fi'

  const style = {
    fontSize: size || '1.25rem',
    height: size || '1.25rem'
  }

  let Icon = bsIcons[name]
  if (!Icon) Icon = ioIcons[name]
  if (!Icon) Icon = ioIcons[name]
  if (!Icon) Icon = io5Icons[name]
  if (!Icon) Icon = riIcons[name]
  if (!Icon) return false

  return <Icon style={style} color={color || COLORS.purple} onClick={onClick} />
}

export default Icon
